import { render, staticRenderFns } from "./DocumentPrint3.vue?vue&type=template&id=710a71b7&scoped=true"
import script from "./DocumentPrint3.vue?vue&type=script&lang=js"
export * from "./DocumentPrint3.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrint3.vue?vue&type=style&index=0&id=710a71b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a71b7",
  null
  
)

export default component.exports